import React, { useState ,useEffect} from 'react';
import { Modal, Form, Input, Button, Checkbox, message } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import { useDispatch } from 'react-redux';
import { login, hideLoginModal } from '@/store/slices/authSlice';

const LoginModal = ({ visible }) => {
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const dispatch = useDispatch();

  const handleCancel = () => {
    dispatch(hideLoginModal());
    // 取消则跳转到登录页
    window.location.href = '/admin_login';
  };

  const handleOk = async (values) => {
    const { username, password, remember } = values;
    setLoading(true);
    try {
      const result = await dispatch(login({ username, password })).unwrap();
      message.success('登录成功');
      dispatch(hideLoginModal());
      // 刷新页面以更新所有状态
      window.location.reload();
    } catch (err) {
      message.error(err.message || '登录失败');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      title="登录过期，请重新登录"
      open={visible}
      onCancel={handleCancel}
      footer={null}
      maskClosable={false}
      destroyOnClose
    >
      <Form form={form} onFinish={handleOk} autoComplete="off">
        <Form.Item
          name="username"
          rules={[{ required: true, message: '请输入用户名!' }]}
        >
          <Input prefix={<UserOutlined />} placeholder="用户名" />
        </Form.Item>
        <Form.Item
          name="password"
          rules={[{ required: true, message: '请输入密码' }]}
        >
          <Input.Password prefix={<LockOutlined />} placeholder="密码" />
        </Form.Item>
        <Form.Item name="remember" valuePropName="checked">
          <Checkbox>记住我</Checkbox>
        </Form.Item>
        <Form.Item>
          <Button type="primary" htmlType="submit" loading={loading} block>
            登录
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default LoginModal;